
import { Mic, Music, Calendar, Mail } from "lucide-react";
import { Footerdemo } from "@/components/ui/footer-section";
import { HeroSection } from "@/components/ui/hero-section";
import { Logos3 } from "@/components/ui/logos3";
import { HowItWorks } from "@/components/ui/how-it-works";
import { PricingComparison } from "@/components/ui/pricing-comparison";
import { MeetPodSection } from "@/components/ui/meet-pod-section";
import { MeetCodySection } from "@/components/ui/meet-cody-section";
import { FAQSection } from "@/components/ui/faq-section";
import { RainbowButton } from "@/components/ui/rainbow-button";
import { ContactForm } from "@/components/ui/contact-form";
import { Button } from "@/components/ui/button";

const Index = () => {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    const pricingSection = document.getElementById('pricing');
    pricingSection?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-studio-cream">
      <HeroSection 
        title="Austin's Friendly Neighborhood Podcast Studio"
        description="Affordable recording in a private backyard studio, right off South Congress and minutes from downtown Austin!"
        image="/lovable-uploads/3e072a16-b1ab-4850-8fdd-6b2fd55fa9e9.png"
        actions={[
          {
            text: "Book Now",
            href: "#pricing",
            variant: "custom",
            customButton: <RainbowButton onClick={scrollToPricing}>Book Now</RainbowButton>
          },
          {
            text: "Contact Us",
            href: "#contact",
            variant: "outline",
            onClick: scrollToContact
          }
        ]}
      />

      <Logos3 />
      
      <HowItWorks />

      <MeetPodSection />

      <MeetCodySection />

      <div id="pricing">
        <PricingComparison />
      </div>

      <FAQSection />

      <div id="contact">
        <ContactForm />
      </div>

      <Footerdemo />
    </div>
  );
}

export default Index;
